import axios from "axios";
import { useContext, useEffect, useState, useRef, useCallback } from "react";
import { Bin } from "../../../component/icons";
import Table from "../../../component/table";
import StateContext from "../../../contextAPI/context";
import {
  DisableNewDateTimeComponent,
  ListboxComponent,
  NewDateTimeComponent,
  NewDropdownComponent,
  NewInputComponent,
  NewLinkComponent,
  NewTextareaComponent,
  NewTimeComponent,
} from "../components/customInputs";
import EmbeddedShareModal from "./EmbeddedShareModal";
import UpdateModal from "../components/updateassetentry";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import { useParams } from "react-router-dom";
import moment from "moment";
import DataTable from "react-data-table-component";
import EmbeddedExtendActivity from "../../dashboard/embedded/EmbeddedExtendActivity";
import EmbeddedTransferActivity from "../../dashboard/embedded/EmbeddedTransferActivity";
import { MultiSelect } from "react-multi-select-component";
import Loader from "../../booking/Loader";
import Pageinfo from "../../../component/Alert/Pageinfo";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";
import { checkBlankSpace } from "../../../utils";
import "../activityPerformance.css";
import PerformanceDateTime from "./PerformanceDateTime";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { SET_ACTIVITY } from "../../../redux/constants";
import { getAllAssetByActivityAssignmentId } from "../../../redux/actions/asset";
import {
  assetEntryPerformance,
  deleteActivityPerformance,
  deleteAssetEntryPerformance,
  fieldValueValidation,
  getAllActivities,
  submitActivityPerformance,
  updateActivityPerformanceAction,
  updateAssetEntryPerformance,
  markCompleted,
} from "../../../redux/actions/performance";

const UpdateActivity = ({
  openTab,
  activitydata,
  newjson,
  setNewJson,
  activityPerformance,
  setActivityPerformance,
  fileNames,
  setFileNames,
  activityperformed,
  setActivityPerformed,
  performancevalue,
  setPerformanceValue,
  showactivity,
  obj,
  email,
  useremail,
  userinfo,
  setUserInfo,
  activity_assignment_id,
  editstate,
  setEditState,
  renderdata,
  setRenderData,
  company_id,
  updatePerformanceTable,
  setUpdatePerformanceTable,
  setOpenTab,
  activityName,
  userdept,
  compulsoryactivity,
}) => {
  const dispatch = useDispatch();

  const { email: user_email } = useParams();
  const [header, setHeader] = useState([]);
  const [assetvalue, setAssetValue] = useState({});
  const [editmodal, setEditModal] = useState(false);
  const [a_performance, setA_Performance] = useState([]);
  const {
    setPerformanceId,
    setSubmitPerform,
    submitperform,
    focuscontrolid,
    setFocusControlId,
    checkfocus,
    setCheckFocus,
  } = useContext(StateContext);
  const [validatecontrols, setValidateControls] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedasset, setSelectedAsset] = useState([]);
  const [showallasset, setShowAllAsset] = useState([]);
  const [loader, setLoader] = useState(false);
  const [basedon, setBasedon] = useState("");
  const [basedontype, setBasedonType] = useState("");
  const [userinternal, setUserInternal] = useState(false);
  const inputRef = useRef();
  // Message Information Variables
  const [internaluseralert, setInternalUserAlert] = useState(false);
  const [compulsaryAlert, setCompularyAlert] = useState(false);
  const [validateobj, setValidateObj] = useState([]);
  // Page Info Alert for Common
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");

  // Asset Table List Data
  const [assetList, setAssetList] = useState([]);
  const [assetEntryCompleted, setAssetEntryCompleted] = useState(false);
  const [alreadyperformed, setAlreadyPerformed] = useState(false);
  const [userdetail, setUserDetail] = useState();
  const [filedata, setFileData] = useState([]);

  // Redux States
  const {
    components,
    activity,
    tableInfo,
    fileList,
    units,
    activities,
    customeFields,
    jobId,
  } = useSelector((state) => state.performance);
  const { allAssets } = useSelector((state) => state.assets);
  const { embeddedUserData } = useSelector((state) => state.user);

  var _ = require("underscore");
  // creating state to open the share modal
  const [openShareModal, setOpenShareModal] = useState(false);
  if (Array.isArray(components) && components.length !== 0) {
    components.sort(function (a, b) {
      return a.sequence - b.sequence;
    });
  }

  useEffect(() => {
    if (editstate) {
      ShowAllAssets();
    } else {
      ShowSelectedAssets();
    }
  }, [editstate, tableInfo, allAssets]);

  useEffect(() => {
    if (renderdata && activitydata.based_on === "Container") {
      var value =
        Object.keys(activity).length !== 0
          ? activity.based_on
          : activityPerformance.based_on !== undefined
          ? activityPerformance.based_on
          : "";
      const arr = value.split(",");
      var arr1 = [];
      arr.forEach((ele) => {
        arr1.push({ label: ele, value: ele });
      });
      setSelected(arr1);
    }
  }, [renderdata]);

  useEffect(() => {
    if (activitydata?.based_on === "Container") {
      const arr = [];
      selected.forEach((ele) => {
        arr.push(ele.value);
      });
      setA_Performance({
        ...a_performance,
        based_on: arr, //.toString()
      });
      setActivityPerformance({
        ...activityPerformance,
        based_on: arr, //.toString()
      });
      dispatch({
        type: SET_ACTIVITY,
        payload: { ...activity, based_on: arr.toString() },
      });
    }
  }, [selected]);

  useEffect(() => {
    if (validatecontrols && focuscontrolid !== "") {
      setCheckFocus(true);
      document.getElementById(focuscontrolid).focus();
      setValidateControls(false);
    }
  }, [validatecontrols]);

  useEffect(() => {
    if (submitperform) {
      dispatch({
        type: SET_ACTIVITY,
        payload: {
          ...activity,
          file_name: null,
          file_path: null,
          remarks: "",
          expenses: "",
        },
      });
      setTimeout(() => {
        setSubmitPerform(false);
      }, 2000);
    }
  }, [submitperform]);

  useEffect(() => {
    if (components.length !== 0 && newjson !== 0 && activitydata.length !== 0) {
      setActivityPerformance({
        ...activityPerformance,
        ...{
          custom_fields: newjson,
        },
      });
    }
  }, [newjson]);

  useEffect(() => {
    if (components.length > 0) {
      setHeader([]);
      components.map((item, index) => {
        if (index === 0) {
          if (
            (activitydata.based_on === "Document" &&
              activitydata.label !== "") ||
            activitydata.based_on === "Container"
          ) {
            setHeader((header) => [
              ...header,
              {
                heading:
                  activitydata.based_on === "Document"
                    ? activitydata.label
                    : "Assets",
              },
            ]);
            var label =
              activitydata.based_on === "Document"
                ? activitydata.label
                : "Assets";
            if (activitydata.based_on === "Container") {
              setBasedonType("C" + label);
            } else {
              setBasedonType("D" + label);
            }
          }
        }
        setHeader((header) => [
          ...header,
          {
            heading: item.label === "" ? item.type : item.label,
            custom_field_id: item.id,
          },
        ]);

        if (components.length - 1 === index) {
          if (activitydata.is_upload_allowed === "1") {
            setHeader((header) => [
              ...header,
              {
                heading: "File Upload",
              },
            ]);
          }
          setHeader((header) => [
            ...header,
            {
              heading: "Performance Date/Time",
            },
          ]);
          setHeader((header) => [
            ...header,
            {
              heading: "Remarks",
            },
          ]);
          //}
          setHeader((header) => [
            ...header,
            {
              heading: "Action",
            },
          ]);
        }
      });
      var arr = [];
      if (editstate === false) {
        //activityperformed
        components.forEach((ele) => {
          switch (ele.type) {
            case "text":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "text",
              });
              break;
            case "number":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "number",
              });
              break;
            case "textarea":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "textarea",
              });
              break;
            case "dropdown":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "dropdown",
              });
              break;
            case "date":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "date",
              });
              break;
            case "link":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "link",
              });
              break;
            case "list":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "list",
              });
              break;
            case "time":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "time",
              });
              break;
            case "datetime":
              arr.push({
                custom_field_id: ele.id,
                value: "",
                type: "datetime",
                required: ele.is_required,
                label: ele.label,
              });
              break;
          }
        });
      }
      setNewJson(arr);
    }
    if (components.length === 0) {
      setHeader([]);
      if (
        (activitydata.based_on === "Document" && activitydata.label !== "") ||
        activitydata.based_on === "Container"
      ) {
        setHeader((header) => [
          ...header,
          {
            heading:
              activitydata.based_on === "Document"
                ? activitydata.label
                : "Assets",
          },
        ]);
        var label =
          activitydata.based_on === "Document" ? activitydata.label : "Assets";
        if (activitydata.based_on === "Container") {
          setBasedonType("C" + label);
        } else {
          setBasedonType("D" + label);
        }
      }
      if (activitydata.is_upload_allowed === "1") {
        setHeader((header) => [
          ...header,
          {
            heading: "File Upload",
          },
        ]);
      }
      setHeader((header) => [
        ...header,
        {
          heading: "Performance Date/Time",
        },
      ]);
      setHeader((header) => [
        ...header,
        {
          heading: "Remarks",
        },
      ]);
      setHeader((header) => [
        ...header,
        {
          heading: "Action",
        },
      ]);
    }
  }, [components]);

  useEffect(() => {
    if (header.length > 0 && tableInfo.activity_performances?.length !== 0) {
      let performance = [];
      let arr = [];
      tableInfo.activity_performances?.map((item) => {
        header.map((ele) => {
          item.todo_custom_controls.map((i) => {
            if (ele.custom_field_id === i.custom_field_id) {
              performance.push(i);
            }
          });
          if (
            ele.heading === basedontype.slice(1) &&
            basedontype.slice(0, 1) === "C"
          ) {
            var based_on = {
              value: item.based_on,
              performance_id: item.activity_performance_id,
            };
            performance.push(based_on);
          } else if (
            ele.heading === basedontype.slice(1) &&
            basedontype.slice(0, 1) === "D"
          ) {
            var based_on = {
              value: item.based_on,
              performance_id: item.activity_performance_id,
            };
            performance.push(based_on);
          } else if (ele.heading === "File Upload") {
            let filesName = [];
            for (const f of fileList) {
              if (item.activity_performance_id === f.activity_performance_id) {
                filesName.push(f.file_name);
              }
            }
            var expenses = {
              value: filesName.join(", "),
              performance_id: item.activity_performance_id,
            };
            performance.push(expenses);
          } else if (ele.heading === "Performance Date/Time") {
            performance.push({
              value: moment(item.date).utc().format("DD-MM-YYYY hh:mm A"),
              performance_id: item.activity_performance_id,
            });
          } else if (ele.heading === "Remarks") {
            var remarks = {
              value: item.remarks,
              performance_id: item.activity_performance_id,
            };
            performance.push(remarks);
          }
        });
        arr.push(performance);
        performance = [];
      });
      setPerformanceValue(arr);
    }
    if (tableInfo.activity_performances?.length === 0) {
      setTableData([]);
    }
  }, [header, tableInfo, fileList]);

  useEffect(() => {
    if (Object.keys(activitydata).length !== 0) {
      if (document.getElementById("datepickr") !== null) {
        const date_value = document.getElementById("datepickr").value;
        setActivityPerformance({
          ...activityPerformance,
          date: date_value,
        });
      }
      let name =
        activitydata.based_on === "Container"
          ? "Container"
          : activitydata.label !== "" && activitydata.label !== null
          ? activitydata.label
          : "Document no.";
      setBasedon(name);
      let filesData = JSON.parse(activitydata.mandatory_upload) || [];

      const newFileData = filesData.map((item) => {
        return {
          id: Math.random(),
          upload: [],
          ...item,
        };
      });
      setFileData(newFileData);
    }
  }, [activitydata]);

  // Asset Entry Table Data Mapping
  useEffect(() => {
    createAssetList();
    return () => {
      setAssetList([]);
    };
  }, [units]);

  const getPerformActivity = useCallback(
    (activityData, label) => {
      if (label) {
        if (Boolean(Number(userinfo?.activity?.is_extensible))) {
          return true;
        } else {
          if (activityData?.user_id) {
            return embeddedUserData?.user_ids?.includes(activityData.user_id)
              ? true
              : false;
          }

          if (activityData?.user_email) {
            return activityData?.user_email?.toLowerCase() ===
              user_email.toLowerCase()
              ? true
              : false;
          }

          if (activityData?.department_id && activityData?.user_id === null) {
            const result = userdetail?.user_departments?.find(
              (item) => item.department_id === activityData?.department_id
            );
            return result ? true : false;
          }
        }
      }
      if (activityData?.user_id) {
        return embeddedUserData?.user_ids?.includes(activityData.user_id)
          ? true
          : false;
      }

      if (activityData?.user_email) {
        return activityData?.user_email?.toLowerCase() ===
          user_email.toLowerCase()
          ? true
          : false;
      }

      if (activityData?.department_id && activityData?.user_id === null) {
        const result = userdetail?.user_departments?.find(
          (item) => item.department_id === activityData?.department_id
        );
        return result ? true : false;
      }
    },
    [
      embeddedUserData?.user_ids,
      user_email,
      userdetail?.user_departments,
      userinfo?.activity?.is_extensible,
    ]
  );

  useEffect(() => {
    const status = getPerformActivity(userinfo);
    setCompularyAlert(false);
    setUserInternal(false);
    if (status !== undefined) {
      setInternalUserAlert(!status);
    }
    if (userinfo.can_perform === false) {
      setCompularyAlert(true);
    }
  }, [userinfo]);

  useEffect(() => {
    if (internaluseralert || compulsaryAlert) {
      setUserInternal(true);
    }
  }, [compulsaryAlert, userinternal, internaluseralert]);

  useEffect(() => {
    if (userinternal)
      inputRef.current.flatpickr.altInput.disabled = userinternal;
  }, [userinternal]);

  useEffect(() => {
    if (showAlert === true) {
      setTimeout(() => {
        setShowAlert(false);
        setMessage("");
      }, 5000);
    }
  }, [showAlert]);

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_URL}/user/embedded/getUserByEmailAndCompanyId/${company_id}/${user_email}`
    );
    if (result.data.status) {
      setUserDetail(result.data.data);
    }
  };

  // Creating asset table list with data
  const createAssetList = async () => {
    try {
      if (units !== null && units?.length !== 0) {
        const assetEntryData = await axios.get(
          `${process.env.REACT_APP_API_URL}/assetentry/${activity_assignment_id}`
        );
        const entryList = assetEntryData.data?.data;
        const listData = [];
        if (entryList.length === 0) {
          units.forEach((item) => {
            for (let i = 0; i < item.quantity; i++) {
              listData.push({
                id: Math.random(),
                asset_type: item.asset_type,
                activity_assignment_id,
                asset_name: "",
              });
            }
          });
        }
        if (entryList.length !== 0) {
          units.forEach((item) => {
            for (let i = 0; i < item.quantity; i++) {
              const check = entryList.findIndex(
                (ele) => ele.asset_type === item.asset_type
              );
              if (check !== -1) {
                listData.push({
                  id: Math.random(),
                  completed: true,
                  ...entryList[check],
                });
                entryList.splice(check, 1);
              } else {
                listData.push({
                  id: Math.random(),
                  asset_type: item.asset_type,
                  activity_assignment_id,
                  asset_name: "",
                  completed: false,
                });
              }
            }
          });
        }
        dispatch(getAllAssetByActivityAssignmentId(activity_assignment_id));
        setAssetList(listData);
        // getAllAsset();
      }
    } catch (error) {
      console.log("Error", error.response);
    }
  };

  const uploadFile = async (e, id) => {
    setLoader(true);
    let fileSize = 0;
    for (const item of e) {
      let fileName = "";
      var filetype = item.name.split(".").pop();
      fileName = item.name;
      const type = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpeg",
        "jpg",
        "png",
        "bmp",
        "txt",
      ];
      fileSize = item.size / 1024 / 1024; // in MiB
      if (fileSize > 2) {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} file name exceeds file size 2 MB.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }

      if (!type.includes(filetype.toLowerCase())) {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} must be among these pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, txt.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      setFileNames((prev) => [...prev, { id, fileName: fileName }]);
    }
    setFileData((prev) => {
      const index = prev.findIndex((item) => item.id === id);
      prev[index].upload.push(...e);
      return prev;
    });
    // setFileNames((prev) => {
    //   const filterdata = prev.filter((ele) => id !== ele.id);
    //   return [...filterdata, { id, fileName: fileName }];
    // });
    setLoader(false);
  };

  const handleActivity = (e) => {
    const { name, value } = e.target;
    if (Object.keys(activity).length !== 0) {
      dispatch({ type: SET_ACTIVITY, payload: { ...activity, [name]: value } });
    }
    setActivityPerformance({ ...activityPerformance, [name]: value });
  };

  const checkValidation = async (activitydata, type) => {
    if (validateobj.length !== 0) {
      return;
    }
    var bool = false;
    if (activityPerformance.date === "") {
      swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`Date/time is mandatory field and it cannot be empty. Please select valid data and time.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
      return;
    }

    if (
      activityPerformance.custom_fields !== undefined &&
      activityPerformance.custom_fields.length !== 0
    ) {
      label: for (let item = 0; item < components.length; item++) {
        for (
          let ele = 0;
          ele < activityPerformance.custom_fields.length;
          ele++
        ) {
          if (
            components[item].id ===
            activityPerformance.custom_fields[ele].custom_field_id
          ) {
            if (
              components[item].is_required &&
              components[item].type !== "link"
            ) {
              if (
                (activityPerformance.custom_fields[ele].value === "" ||
                  activityPerformance.custom_fields[ele].value === undefined) &&
                activityPerformance.custom_fields[ele].required &&
                activityPerformance.custom_fields[ele].type === "datetime"
              ) {
                setShowAlert(true);
                setMessage({
                  type: "info",
                  title: "Datetime Validation",
                  message: `${activityPerformance.custom_fields[ele].label} is required and it cannot be empty.`,
                });
                bool = false;
                break label;
              } else if (activityPerformance.custom_fields[ele].value !== "")
                bool = true;
              else {
                bool = false;
                break label;
              }
            } else bool = true;

            if (components[item].type === "text") {
              // if (
              //   components[item].min !== null &&
              //   components[item].max !== null
              // ) {
              if (
                (components[item].min <=
                  activityPerformance.custom_fields[ele].value.length &&
                  activityPerformance.custom_fields[ele].value.length <=
                    components[item].max) ||
                activityPerformance.custom_fields[ele].value === ""
              )
                bool = true;
              else {
                bool = false;
                break label;
              }
              // }
            } else if (components[item].type === "number") {
              if (
                (components[item].min <=
                  parseInt(activityPerformance.custom_fields[ele].value) &&
                  parseInt(activityPerformance.custom_fields[ele].value) <=
                    components[item].max) ||
                activityPerformance.custom_fields[ele].value === ""
              )
                bool = true;
              else {
                bool = false;
                break label;
              }
            } else if (components[item].type === "date") {
              var date = document.getElementById(components[item].id);
              if (date.value !== "") {
                if (
                  date.min <= date.value &&
                  (date.max >= date.value || date.max === "")
                )
                  bool = true;
                else {
                  bool = false;
                  break label;
                }
              }
            }
          }
        }
      }
    } else {
      bool = true;
    }
    if (
      activitydata.based_on === "Container" &&
      !bool &&
      components.length === 0
    ) {
      if (activityPerformance.based_on === "") {
        window.alert("Please select container value.");
        return;
      }
      bool = true;
    }
    if (activitydata.mandatory_upload !== "" && bool) {
      for (const item of filedata) {
        if (item.mandatory_upload === true && item.upload.length === 0) {
          swal({
            content: (
              <CustomeModal
                type="warning"
                title="Warning!"
                content={`${item.filename} file is required mandatory upload.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          return;
        }
      }
    }

    // if (
    //   activitydata.based_on === "Document" &&
    //   !bool &&
    //   components.length === 0
    // ) {
    //   if (activityPerformance.based_on === "") {
    //     window.alert("Please select document value.");
    //     return;
    //   }
    //   bool = true;
    // }
    if (bool) {
      setLoader(true);
      delete activityPerformance["date"];
      const date_value = document.getElementById("datepickr").value;
      activityPerformance["date"] = moment.utc(date_value).format();

      const request = {
        onActivityCompleted: () => {
          dispatch(getAllActivities(activity_assignment_id, (res) => {}));
        },
        onSuccess: () => {
          setLoader(false);
          setSelected([]);
          setSubmitPerform(true);
          setFileData([]);
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content="Your To Do performance successfully submitted"
              />
            ),
            // content: <CustomeModal type="success" title="Success!" content={`${type === "Save" ? "Your To Do performance sucessfully saved." : "Your To Do performance sucessfully completed."}`} />,
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
          setActivityPerformance({
            ...activityPerformance,
            custom_fields: activitydata.based_on === "Container" ? newjson : [],
            remarks: "",
            based_on: "",
            expenses: "",
            file_name: null,
            file_path: null,
          });
          setFileNames([]);
        },
        onError: () => {
          setLoader(false);
        },
        failedActivityPerform: () => {
          setLoader(false);
          swal({
            content: (
              <CustomeModal
                type="error"
                title="Error!"
                content={`Your To Do can not performance sucessfully.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        },
      };
      dispatch(
        submitActivityPerformance(
          activityPerformance,
          filedata,
          userinfo,
          activitydata,
          allAssets,
          tableInfo,
          obj,
          type,
          request
        )
      );
    }
  };

  const updateActivityPerformance = async () => {
    const date_value = document.getElementById("datepickr").value;
    const utcDate = moment.utc(date_value).format();
    const payload = {
      ...activity,
      date: utcDate,
      activity_assignment_mapping_id: userinfo.activity_assignment_mapping_id,
    };

    const request = {
      onSuccess: () => {
        setSelected([]);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Your To Do performance has been updated successfully.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        setActivityPerformance({
          ...activityPerformance,
          custom_fields: activitydata.based_on === "Container" ? newjson : [],
          remarks: "",
          based_on: activitydata.label === "" ? null : "",
          expenses: "",
          file_name: null,
          file_path: null,
        });
        setFileData([]);
        setFileNames([]);
      },
      onError: () => {
        setSelected([]);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Failed to update your To Do performance.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        setActivityPerformance({
          ...activityPerformance,
          custom_fields: [],
          remarks: "",
          based_on: activitydata.label === "" ? null : "",
          expenses: "",
          file_name: null,
          file_path: null,
        });
        setFileData([]);
        setFileNames([]);
      },
    };

    dispatch(
      updateActivityPerformanceAction(
        payload,
        filedata,
        userinfo,
        activity,
        request
      )
    );
  };

  const renderInput = (input, index, internaluser, validateobj, userinfo) => {
    const selected = index;
    const props = {
      ...input,
      index,
      internaluser,
      validateobj,
      selected,
      userinfo,
      onChange: handleChange,
      onBlur: ApplyValidation,
    };
    if (input.type === "link") {
      return <NewLinkComponent {...props} />;
    } else if (input.type === "dropdown") {
      return <NewDropdownComponent {...props} />;
    } else if (input.type === "textarea") {
      return <NewTextareaComponent {...props} />;
    } else if (input.type === "list") {
      return <ListboxComponent {...props} />;
    } else if (input.type === "time") {
      return <NewTimeComponent {...props} />;
    } else if (input.type === "datetime" && internaluser) {
      return <DisableNewDateTimeComponent {...props} />;
    } else if (input.type === "datetime") {
      return <NewDateTimeComponent {...props} />;
    } else {
      return <NewInputComponent {...props} />;
    }
  };
  const handleChange = (e, id, type) => {
    const value = type === "datetime" ? e[0] : e.target.value;
    if (editstate && Object.keys(activity).length > 1) {
      activity.custom_fields.forEach((ele, index) => {
        if (ele.custom_field_id === id) {
          let copyjson = JSON.parse(JSON.stringify(activity.custom_fields));
          if (type === "text" || type === "textarea") {
            var val = value ? checkBlankSpace(value) : false;
            if (val) {
              if (validateobj.length === 0) {
                setValidateObj([
                  ...validateobj,
                  { id: ele.custom_field_id, value: value },
                ]);
              } else {
                setValidateObj((prev) => {
                  let found =
                    prev.filter((item) => item.id === ele.custom_field_id) ||
                    [];
                  if (found.length === 0) {
                    prev.push({ id: ele.custom_field_id, value: value });
                  }
                  return prev;
                });
              }
            } else if (validateobj.length !== 0) {
              validateobj.forEach((item, i) => {
                if (item.id === ele.custom_field_id) {
                  var arr = [...validateobj]; // make a separate copy of the array
                  var index = arr.indexOf(item);
                  if (index !== -1) {
                    arr.splice(index, 1);
                    setValidateObj(arr);
                  }
                }
              });
            }
          }
          copyjson[index].value = value;
          dispatch({
            type: SET_ACTIVITY,
            payload: { ...activity, custom_fields: copyjson },
          });
        }
      });
    } else {
      newjson.forEach((ele, index) => {
        if (ele.custom_field_id === id) {
          let copyjson = [...newjson];
          if (ele.type === "text" || ele.type === "textarea") {
            var val = value ? checkBlankSpace(value) : false;
            if (val) {
              if (validateobj.length === 0) {
                setValidateObj([
                  ...validateobj,
                  { id: ele.custom_field_id, value: value },
                ]);
              } else {
                setValidateObj((prev) => {
                  let found =
                    prev.filter((item) => item.id === ele.custom_field_id) ||
                    [];
                  if (found.length === 0) {
                    prev.push({ id: ele.custom_field_id, value: value });
                  }
                  return prev;
                });
              }
            } else if (validateobj.length !== 0) {
              validateobj.map((item, i) => {
                if (item.id === ele.custom_field_id) {
                  var arr = [...validateobj]; // make a separate copy of the array
                  var index = arr.indexOf(item);
                  if (index !== -1) {
                    arr.splice(index, 1);
                    setValidateObj(arr);
                  }
                }
              });
            }
          }
          copyjson[index].value = value;
          setActivityPerformance({
            ...activityPerformance,
            ...{ custom_fields: copyjson },
          });
        }
      });
    }
  };
  const SetAsset = (e, activitydata) => {
    const { name, value } = e.target;
    if (activitydata !== undefined) {
      var documentName =
        activitydata.label !== "" && activitydata.label !== null
          ? activitydata.label
          : "Document no.";
    }
    if (name === "Container") {
      setA_Performance({ ...a_performance, based_on: value });
      setActivityPerformance({ ...activityPerformance, based_on: value });
      dispatch({
        type: SET_ACTIVITY,
        payload: { ...activity, based_on: value },
      });
    } else if (name === documentName) {
      setA_Performance({ ...a_performance, based_on: value });
      if (value === "") {
        setActivityPerformance({ ...activityPerformance, based_on: [] });
      } else {
        setActivityPerformance({ ...activityPerformance, based_on: [value] });
      }
      dispatch({
        type: SET_ACTIVITY,
        payload: { ...activity, based_on: value },
      });
    }
  };
  const ShowSelectedAssets = (e) => {
    var assetarr = [];
    var headerarr = [];
    if (tableInfo.activity_performances !== undefined) {
      allAssets.forEach((ele) => {
        assetarr.push(ele.asset_name.concat("-", ele.asset_type));
      });
      tableInfo.activity_performances.forEach((ele) => {
        headerarr.push(ele.based_on);
      });
      var values = _.difference(assetarr, headerarr);
      var options = [];
      if (values.length !== 0) {
        values.forEach((val) => {
          options.push({ label: val, value: val });
        });
        setSelectedAsset(options);
      } else {
        setSelectedAsset([]);
      }
    }
  };
  const ShowAllAssets = (e) => {
    var options = [];
    allAssets.forEach((ele) => {
      const val = ele.asset_name.concat("-", ele.asset_type);
      options.push({ label: val, value: val });
    });
    setShowAllAsset(options);
  };
  const handleAsset = async () => {
    const check = assetList.find((item) => item.asset_name !== "");
    if (typeof check === "undefined") {
      return swal({
        content: (
          <CustomeModal
            type="warning"
            title="Warning!"
            content={`Please provide atleast one asset name for asset type to submit details.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }

    const payload = [];
    assetList.forEach((item) => {
      if (item.asset_name !== "") {
        payload.push(item);
      }
    });

    const request = {
      onSuccess: (res) => {
        if (res.status) {
          createAssetList();
          if (res.check) {
            dispatch(getAllActivities(activity_assignment_id, (res) => {}));
          }
          setSelected([]);
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Asset entry successfully updated.`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
      },
    };

    dispatch(assetEntryPerformance(payload, request));
  };

  const handleEditAssetEntry = async (updateasset) => {
    var valid = false;
    if (units !== null) {
      units.forEach((ele) => {
        if (ele.uom === updateasset.asset_type) {
          valid = true;
        }
      });
    }

    if (valid) {
      const request = {
        onSuccess: () => {
          setEditModal(false);
          dispatch(
            getAllAssetByActivityAssignmentId(
              activity_assignment_id,
              (res) => {}
            )
          );
        },
      };
      dispatch(updateAssetEntryPerformance(assetvalue, updateasset, request));
    }
  };
  const handleDeleteAssetEntry = async (asset_entry_id) => {
    const request = {
      onSuccess: () => {
        createAssetList();
        setSelected([]);
        dispatch(getAllAssetByActivityAssignmentId(activity_assignment_id));
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Asset entry successfully deleted.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    dispatch(deleteAssetEntryPerformance(asset_entry_id, request));
  };

  const getActivityPerformance = (id) => {
    if (tableInfo !== []) {
      tableInfo.activity_performances.forEach((ele) => {
        if (ele.activity_performance_id === id) {
          dispatch({
            type: SET_ACTIVITY,
            payload: {
              ...activity,
              activity_id: ele.activity_id,
              performance_id: ele.activity_performance_id,
              based_on: ele.based_on,
              file_name: ele.file_name,
              remarks: ele.remarks,
              expenses: ele.expenses,
              date: ele.date,
              custom_fields: ele.todo_custom_controls,
            },
          });
        }
      });
    }
    setEditState(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/activityperformance/${id}`)
      .then((res) => {
        setA_Performance(res.data.data[0]);
        setPerformanceId(res.data.data[0].activity_performance_id);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const removeActivityPerformance = async (id) => {
    const request = {
      onSuccess: () => {
        setEditState(false);
        setSubmitPerform(true);
        setRenderData(false);
      },
      setActivityStatus: () => {
        dispatch(getAllActivities(activity_assignment_id, (res) => {}));
      },
    };

    dispatch(deleteActivityPerformance(id, userinfo, request));
  };

  const checkAssetEntryIsPerform = async (asset_id) => {
    try {
      const result = await axios.get(
        `${process.env.REACT_APP_API_URL}/assetentry/byId/${asset_id}`
      );
      const asset_checking_name =
        result.data.data.asset_name + "-" + result.data.data.asset_type;
      for (const item of activities) {
        if (item.activity.based_on === "Container") {
          for (const ele of item.activity_performances) {
            if (ele?.based_on.trim() === asset_checking_name.trim()) {
              return false;
            }
          }
        }
      }
      setAssetValue(result.data.data);
      return true;
    } catch (error) {
      console.log(error);
    }
  };

  /*----------- Creating state to show modal pop-up ------------- */
  const [isExtend, setIsExtend] = useState(false);
  const [isTransfer, setIsTransfer] = useState(false);

  /*------------------------- Data Table For Activity Performance ----------------------*/

  const [tableColumn, setTableColumn] = useState([]);
  const [tableData, setTableData] = useState([]);

  // Creating table headers
  useEffect(() => {
    if (header.length > 0) {
      const arr = [];
      header.forEach((el, index) => {
        const obj = {};
        if (index === header.length - 1) {
          obj.name = el.heading;
          obj.selector = (row) => row.action;
        } else if (index === 1) {
          obj.name = el.heading;
          obj.selector = (row) => row[`item${index}`];
          obj.sortable = true;
          obj.hide = "sm";
        } else if (index === 2) {
          obj.name = el.heading;
          obj.selector = (row) => row[`item${index}`];
          obj.sortable = true;
          obj.hide = "md";
        } else if (index > 2 && index !== header.length - 2) {
          obj.name = el.heading;
          obj.selector = (row) => row[`item${index}`];
          obj.sortable = true;
          obj.omit = true;
        } else {
          obj.name = el.heading;
          obj.selector = (row) => row[`item${index}`];
          obj.sortable = true;
        }

        arr.push(obj);
      });
      if (activitydata?.allow_user_edit === false) {
        arr.pop();
      }

      setTableColumn(arr);
    }
  }, [header, activitydata]);

  // Creating table body content
  useEffect(() => {
    if (performancevalue.length > 0) {
      let arr = [];
      performancevalue.forEach((item, index) => {
        const obj = {};
        item.forEach((element, index) => {
          if (
            element.value !== null &&
            element.value.length === 24 &&
            element.value.slice(10, 11) == "T"
          ) {
            obj[`item${index}`] = moment(element.value).format(
              "DD-MM-YYYY hh:mm A"
            );
          } else {
            obj[`item${index}`] = element.value;
          }
        });
        obj[`action`] = (
          <div className="flex item-center justify-between space-x-3">
            <div title="Edit">
              <span
                className="fa-light fa-pen text-base cursor-pointer"
                style={{ color: "#9297a2" }}
                onClick={(e) => {
                  e.stopPropagation();
                  const status = getPerformActivity(userinfo);
                  if (status) {
                    getActivityPerformance(item[1].performance_id);
                    setRenderData(true);
                  } else {
                    setInternalUserAlert(true);
                  }
                }}
              ></span>
            </div>
            <div title="Delete">
              <span
                className="fa-light fa-trash-can text-base cursor-pointer"
                style={{ color: "#eb5757" }}
                onClick={(e) => {
                  e.stopPropagation();
                  const status = getPerformActivity(userinfo);
                  if (status) {
                    swal({
                      content: (
                        <CustomeModal
                          type="delete"
                          title="Are you sure?"
                          content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                          onDelete={() =>
                            removeActivityPerformance(item[1].performance_id)
                          }
                        />
                      ),
                      buttons: false,
                      closeOnClickOutside: false,
                      closeOnEsc: false,
                    });
                  } else {
                    setInternalUserAlert(true);
                  }
                }}
              ></span>
            </div>
          </div>
        );

        if (activitydata?.allow_user_edit === false) {
          delete obj["action"];
        }
        arr.push(obj);
      });
      setTableData(arr);
    } else {
      setTableData([]);
    }
  }, [performancevalue, activitydata]);

  //  Internally, customStyles will deep merges your customStyles with the default styling.
  const customStyles = {
    headCells: {
      style: {
        fontFont: "24px",
        fontWeight: "bold",
      },
    },
  };

  // Making expandable in specific height
  const [width, setWidth] = useState();

  const windowResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  useEffect(() => {
    const data = activities.find(
      (item) => item.activity_id === activitydata.id
    );
    if (data) {
      if (
        (data.status === "completed" ||
          data.status === "completed with delay") &&
        !editstate &&
        tableData.length !== 0
      ) {
        setAlreadyPerformed(true);
        setUserInternal(true);
      }
    }
    return () => {
      setAlreadyPerformed(false);
      setUserInternal(false);
    };
  }, [activities, activitydata, editstate, tableData]);

  useEffect(() => {
    let check = false;
    if (activitydata.asset_entry === true) {
      for (const item of assetList) {
        if (!item.completed) {
          check = true;
          break;
        }
      }
    }
    if (check) {
      setAssetEntryCompleted(false);
    } else {
      setAssetEntryCompleted(true);
    }
  }, [activitydata, assetList]);

  useEffect(() => {
    if (document.getElementsByClassName("dropdown-container")[0]?.classList) {
      if (userinternal) {
        document
          .getElementsByClassName("dropdown-container")[0]
          .classList.add("disabled-multiselect-dropdown");
      } else {
        document
          .getElementsByClassName("dropdown-container")[0]
          .classList.remove("disabled-multiselect-dropdown");
      }
    }
  }, [userinternal]);

  // hide and show columns on desktop size
  const ExpandedComponent = ({ data }) => {
    return (
      <>
        {Object.keys(data).map((element, index) => {
          if (
            index > 2 &&
            index !== header.length - 2 &&
            index !== header.length - 1
          ) {
            return (
              <p className="px-4 mt-2 text-xs">
                <span className="font-semibold">{header[index]?.heading}:</span>{" "}
                {data[`item${index}`]}
              </p>
            );
          }
        })}
      </>
    );
  };
  const ApplyValidation = (e, id) => {
    const payload = {
      value: e.target.value.slice(0, 11),
    };

    const request = {
      onSuccess: (res) => {
        if (res.data[0].status === 1) {
          setCheckFocus(false);
          return;
        }
        if (res.data[0].status === 0) {
          setCheckFocus(false);
          setValidateControls(true);
          setShowAlert(true);
          setMessage({
            type: "info",
            title: "Validation Failed.",
            message: res.data[0].message,
          });
        } else {
          setCheckFocus(true);
        }
      },
      onError: () => {
        setShowAlert(true);
        setMessage({
          type: "info",
          title: "Validation Failed.",
          message:
            "Something went wrong, Please make sure control value is not empty and correct. try again later!",
        });
      },
    };

    dispatch(fieldValueValidation(id, payload, request));
  };

  const handleAssetText = (item, value) => {
    setAssetList((prev) => {
      const index = prev.findIndex((ele) => ele.id === item.id);
      if (index !== -1) {
        prev[index].asset_name = value;
        return [...prev];
      }
    });
  };

  const handleComplete = (activitydata, type) => {
    const request = {
      onActivityCompleted: () => {
        dispatch(getAllActivities(activity_assignment_id, (res) => {}));
      },
      failedActivityPerform: () => {
        setLoader(false);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Your To Do can not mark as a completed.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };

    if (activitydata.based_on === "Document") {
      dispatch(
        markCompleted(
          activitydata,
          tableInfo,
          activityPerformance,
          allAssets,
          userinfo,
          obj,
          request
        )
      );
    }

    if (
      activitydata.based_on === "Container" &&
      tableInfo.activity_performances.length === allAssets.length
    ) {
      dispatch(
        markCompleted(
          activitydata,
          tableInfo,
          activityPerformance,
          allAssets,
          userinfo,
          obj,
          request,
          showallasset
        )
      );
    }

    if (
      activitydata.based_on === "Container" &&
      tableInfo.activity_performances.length !== allAssets.length
    ) {
      if (
        activitydata.based_on === "Container" &&
        activityPerformance.based_on !== null &&
        activityPerformance.based_on[0] !== null &&
        activityPerformance.based_on?.length !== 0
      ) {
        checkValidation(activitydata, "Complete");
      } else {
        setShowAlert(true);
        setMessage({
          type: "info",
          title: "Field Validation",
          message: `${basedon} is required and it cannot be empty. Please add some`,
        });
      }
    }
  };

  return (
    <div id="tabAdded" className={openTab === 1 ? "block space-y-2" : "hidden"}>
      <div className="md:flex flex-auto md:justify-between md:items-center space-y-2 md:space-y-0 py-4 border-b">
        <div className="text-base space-x-2">
          {jobId && (
            <span
              className="font-medium cursor-pointer hover:underline hover:text-[--bg-color-500]"
              onClick={(e) => setOpenTab(2)}
            >
              {jobId}
            </span>
          )}
          {activityName && (
            <>
              <span>/</span>
              <span className="font-medium">{activityName}</span>
            </>
          )}
        </div>
        <div className="space-x-2 flex justify-between md:justify-end items-center w-full md:w-1/2">
          <button
            className={`btn-xs ${
              !getPerformActivity(userinfo, "extend") ||
              userinfo.status === "completed with delay" ||
              userinfo.status === "completed" ||
              !userinfo.can_perform ||
              userinternal ||
              !Number(userinfo.activity.is_extensible)
                ? "!bg-slate-100 !border-slate-200 pointer-events-none"
                : "!bg-white !border-slate-200 hover:!border-slate-300"
            } btn-xs text-slate-600 text-sm md:flex-grow-0 flex-grow`}
            onClick={() => setIsExtend(true)}
          >
            <span className="fa-duotone fa-calendar-check fill-current text-slate-100 mr-2"></span>
            Extend
          </button>
          <button
            className={`btn-xs ${
              !getPerformActivity(userinfo) ||
              userinfo.status === "completed with delay" ||
              userinfo.status === "completed" ||
              !userinfo.can_perform ||
              userinternal
                ? "!bg-slate-100 !border-slate-200 pointer-events-none"
                : "!bg-white !border-slate-200 hover:!border-slate-300"
            } btn-xs text-slate-600 text-sm md:flex-grow-0 flex-grow`}
            onClick={() => setIsTransfer(true)}
          >
            <span className="fa-duotone fa-arrows-repeat fill-current text-slate-100 mr-2"></span>
            Transfer
          </button>
          <button
            className="btn-xs !bg-[--bg-color-500] text-white text-sm md:flex-grow-0  flex-grow"
            onClick={(e) => setOpenShareModal(true)}
          >
            <span className="fas fa-share fill-current text-slate-100 mr-2"></span>
            Share
          </button>
        </div>
      </div>
      {!userinfo.can_perform && (
        <Pageinfo
          type="info"
          title="To Do is Locked"
          message={`Once ${compulsoryactivity} is completed this To Do unlocks.`}
          open={compulsaryAlert}
          setOpen={setCompularyAlert}
          close={false}
        />
      )}

      {internaluseralert && !compulsaryAlert && (
        <Pageinfo
          type="info"
          title="To Do not Assigned to You"
          message={`Only ${userdept} can perform this To Do.`}
          open={internaluseralert}
          setOpen={setInternalUserAlert}
        />
      )}

      {alreadyperformed && !internaluseralert && !compulsaryAlert && (
        <Pageinfo
          type="info"
          title="Activity already performed"
          message="User has already performed this activity."
          open={alreadyperformed}
          setOpen={setAlreadyPerformed}
          close={false}
        />
      )}

      {showAlert && message !== "" && (
        <Pageinfo
          type={message.type}
          title={message.title}
          message={message.message}
          open={showAlert}
          setOpen={setShowAlert}
        />
      )}
      {showactivity && activitydata.asset_entry === true ? (
        <>
          <div className="w-full">
            <div className="border w-full bg-white rounded-md">
              <Table>
                <tr className="h-11">
                  <th className="py-1">Asset Type</th>
                  <th className="py-1">Asset Name</th>
                  <th className="py-1">Action</th>
                </tr>
                {assetList.map((item) => (
                  <tr key={item.id} className="h-11">
                    <td className="text-center text-gray-600">
                      {item.asset_type}
                    </td>
                    <td className="text-center text-gray-600">
                      <input
                        type="text"
                        placeholder="Asset Name"
                        value={item.asset_name}
                        className={`form-input ${
                          item.completed && "bg-slate-100 cursor-not-allowed"
                        }`}
                        onChange={(e) => handleAssetText(item, e.target.value)}
                        disabled={item.completed}
                      />
                    </td>
                    <td className="text-center">
                      <span
                        className="fa-light fa-trash-can text-base cursor-pointer"
                        style={{ color: "#eb5757" }}
                        onClick={async (e) => {
                          e.stopPropagation();
                          const status = getPerformActivity(userinfo);
                          if (status) {
                            const check = await checkAssetEntryIsPerform(
                              item.asset_entry_id
                            );
                            if (check) {
                              swal({
                                content: (
                                  <CustomeModal
                                    type="delete"
                                    title="Are you sure?"
                                    content="All of your data will be permanently removed from our servers forever. This action cannot be undone."
                                    onDelete={() =>
                                      handleDeleteAssetEntry(
                                        item.asset_entry_id
                                      )
                                    }
                                  />
                                ),
                                buttons: false,
                                closeOnClickOutside: false,
                                closeOnEsc: false,
                              });
                            } else {
                              setShowAlert(true);
                              setMessage({
                                type: "info",
                                title: "Asset Entry Not Deletable",
                                message:
                                  "This asset entry is already perform by a user. You cannot be edit or delete this asset entry.",
                              });
                            }
                          } else {
                            setInternalUserAlert(true);
                          }
                        }}
                      ></span>
                    </td>
                  </tr>
                ))}
              </Table>
            </div>
            <div className="flex justify-end mt-2">
              <button
                // className="bg-blue-700 hover:bg-[--bg-color-600] text-white rounded-lg text-sm px-2.5 py-1.5 m-1 text-center flex justify-center"
                className={`flex items-center flex-initial btn-sm bg-[--bg-color-500] hover:bg-[--bg-color-600] text-white whitespace-nowrap ${
                  assetEntryCompleted && "!bg-[--bg-color-300] cursor-not-allowed"
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  const status = getPerformActivity(userinfo);
                  if (status) {
                    handleAsset();
                  } else {
                    setInternalUserAlert(true);
                  }
                }}
                disabled={assetEntryCompleted}
              >
                Update
              </button>
            </div>
          </div>
        </>
      ) : null}
      <UpdateModal
        id={assetvalue}
        searchId="edit"
        modalOpen={editmodal}
        setModalOpen={setEditModal}
        handleEditAssetEntry={handleEditAssetEntry}
        userData={embeddedUserData}
        company_id={company_id}
      />
      {/* Modal for share */}
      <EmbeddedShareModal
        modalOpen={openShareModal}
        setModalOpen={setOpenShareModal}
        tableinfo={tableInfo}
        company_id={company_id}
        tableColumn={tableColumn}
        tableData={tableData}
        customeFields={customeFields}
      />
      {/* Modal for transfer activity */}
      <EmbeddedTransferActivity
        modalOpen={isTransfer}
        setModalOpen={setIsTransfer}
        updateTable={updatePerformanceTable}
        setUpdateTable={setUpdatePerformanceTable}
        mappingid={userinfo?.activity_assignment_mapping_id}
        activityId={userinfo?.activity_id}
        activity_assignment_id={userinfo?.activity_assignment_id}
        company_id={company_id}
        email={user_email}
      />

      {/* Modal for extend activity */}
      <EmbeddedExtendActivity
        modalOpen={isExtend}
        setModalOpen={setIsExtend}
        updatePerformanceTable={updatePerformanceTable}
        setUpdatePerformanceTable={setUpdatePerformanceTable}
        mappingid={userinfo?.activity_assignment_mapping_id}
        activity_id={userinfo?.activity_id}
        activity_assignment_id={userinfo?.activity_assignment_id}
        company_id={company_id}
        email={user_email}
      />
      <Loader modalOpen={loader} setModalOpen={setLoader} />
      {showactivity ? (
        <>
          <form onSubmit={(e) => e.preventDefault()}>
            {activitydata.based_on === "Container" ? (
              <div className="flex-auto sm:flex justify-between items-baseline">
                <div className="sm:flex-col sm:justify-center sm:w-1/2 sm:my-0.5 sm:inline-block p-1 rounded transition-all">
                  <label for="assets" className="text-sm font-medium mb-1">
                    Assets <span className="text-rose-500 ml-1">*</span>
                  </label>
                  <br />
                  {editstate && (
                    <MultiSelect
                      options={showallasset}
                      className={`based_on mt-1 ${
                        userinternal ? "bg-slate-100 cursor-not-allowed" : ""
                      }`}
                      value={selected}
                      name="Container"
                      onChange={setSelected}
                      labelledBy="Select"
                      disabled={userinternal}
                    />
                  )}
                  {!editstate && (
                    <MultiSelect
                      options={selectedasset}
                      className={`based_on mt-1 ${
                        userinternal ? "bg-slate-100 cursor-not-allowed" : ""
                      }`}
                      name="Container"
                      value={selected}
                      onChange={setSelected}
                      labelledBy="Select"
                      disabled={userinternal}
                    />
                  )}
                </div>
                {components[0]
                  ? renderInput(
                      components[0],
                      components,
                      userinternal,
                      validateobj,
                      userinfo
                    )
                  : null}
              </div>
            ) : null}
            {activitydata.based_on === "Document" &&
            activitydata.label !== "" ? (
              <div className="flex-auto sm:flex justify-between items-baseline">
                <div className="sm:flex-col sm:justify-center sm:w-1/2 sm:my-0.5 sm:inline-block p-1 rounded transition-all">
                  <label for="assets" className="text-sm font-medium mb-1">
                    {activitydata.label !== "" &&
                    activitydata.label !== " " &&
                    activitydata.label !== null
                      ? activitydata.label
                      : "Document no."}{" "}
                    <span className="text-rose-500">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    placeholder={
                      "Enter" +
                      " " +
                      (activitydata.label !== "" && activitydata.label !== null
                        ? activitydata.label
                        : "Document no.")
                    }
                    name={
                      activitydata.label !== "" && activitydata.label !== null
                        ? activitydata.label
                        : "Document no."
                    }
                    id="docu-no"
                    className={`form-input w-full based_on ${
                      userinternal ? "bg-slate-100 cursor-not-allowed" : ""
                    }`}
                    onChange={(e) => SetAsset(e, activitydata)}
                    onBlur={(e) => {
                      if (
                        activitydata.validation_api_id !==
                          "                                    " &&
                        activitydata.validation_api_id !== null &&
                        checkfocus
                      ) {
                        setFocusControlId("docu-no");
                        ApplyValidation(e, activitydata.validation_api_id);
                      }
                    }}
                    value={
                      Object.keys(activity).length !== 0 && renderdata
                        ? activity.based_on
                        : activityPerformance.based_on !== undefined
                        ? activityPerformance.based_on
                        : ""
                    }
                    disabled={userinternal}
                  />
                </div>
                {components[0]
                  ? renderInput(
                      components[0],
                      components,
                      userinternal,
                      validateobj,
                      userinfo
                    )
                  : null}
              </div>
            ) : null}
            {activitydata.based_on === "Document" &&
            activitydata.label === "" &&
            components[0]
              ? renderInput(
                  components[0],
                  components,
                  userinternal,
                  validateobj,
                  userinfo
                )
              : null}
            {components.length > 0
              ? components.map((comp, index) => {
                  if (index % 2 !== 0 && index !== components.length - 1) {
                    return (
                      <div className="flex-auto sm:flex justify-between items-baseline">
                        {renderInput(
                          components[index],
                          components,
                          userinternal,
                          validateobj,
                          userinfo
                        )}
                        {index + 1
                          ? renderInput(
                              components[index + 1],
                              components,
                              userinternal,
                              validateobj,
                              userinfo
                            )
                          : null}
                      </div>
                    );
                  } else if (
                    index === components.length - 1 &&
                    index % 2 !== 0
                  ) {
                    return renderInput(
                      components[index],
                      components,
                      userinternal,
                      validateobj,
                      userinfo
                    );
                  }
                })
              : null}
            <div
              id="container"
              className="flex-auto sm:flex sm:justify-between py-4 border-b border-t"
            >
              <div className="mx-1 sm:w-1/2">
                <div className="flex-col justify-center w-full inline-block rounded transition-all">
                  <label className="text-sm font-medium mb-1">
                    Performance Date/Time
                    <span className="text-rose-500 ml-1">*</span>
                  </label>
                  {userinternal ? (
                    <PerformanceDateTime
                      inputRef={inputRef}
                      setActivityPerformance={setActivityPerformance}
                      activityPerformance={activityPerformance}
                      userinternal={userinternal}
                    />
                  ) : (
                    <Flatpickr
                      ref={inputRef}
                      data-enable-time
                      options={{
                        enableTime: true,
                        altInput: true,
                        altFormat: "j M, Y h:i K",
                        dateFormat: "Y-m-d h:i K",
                        time_24hr: false,
                        defaultDate: moment().format("YYYY-MM-DD HH:mm"),
                        maxDate: new Date(),
                      }}
                      id="datepickr"
                      onChange={(e) => {
                        const date_value =
                          document.getElementById("datepickr").value;
                        setActivityPerformance({
                          ...activityPerformance,
                          date: date_value,
                        });
                      }}
                      className={`form-input w-full ${
                        userinternal && "bg-slate-100 cursor-not-allowed"
                      }`}
                    />
                  )}
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1 ">
                    Remarks
                  </label>
                  <textarea
                    className={`form-input w-full mb-2 resize-none ${
                      userinternal ? "bg-slate-100 cursor-not-allowed" : ""
                    }`}
                    rows={3}
                    name="remarks"
                    onChange={(e) => handleActivity(e)}
                    value={
                      Object.keys(activity).length !== 0 && renderdata
                        ? activity.remarks
                        : activityPerformance.remarks !== undefined
                        ? activityPerformance.remarks
                        : ""
                    }
                    disabled={userinternal}
                  />
                </div>
              </div>
              {activitydata.is_upload_allowed === "1" && (
                <div className="w-full sm:w-1/2 mx-1">
                  <div>
                    <p className="text-sm font-medium pl-4">Upload documents</p>
                    <div
                      className={`py-4 py-0.5 ${
                        userinternal && "cursor-not-allowed"
                      }`}
                    >
                      <div
                        className={`bg-white ${
                          activitydata.expense_charges === "1"
                            ? "min-h-[220px]"
                            : "min-h-[150px]"
                        } border rounded-md`}
                      >
                        {filedata?.map((item) => {
                          return (
                            <div className="flex justify-between items-center py-1.5 px-2 border-b-2">
                              <div className="w-full">
                                <div className="flex flex-row items-center justify-between">
                                  <span className="text-sm mr-2">
                                    {item.filename}
                                    {item.mandatory_upload && (
                                      <span className="text-rose-500 ml-1">
                                        *
                                      </span>
                                    )}
                                  </span>
                                  <input
                                    id={item.id}
                                    type="file"
                                    onChange={(e) => {
                                      uploadFile(e.target.files, item.id);
                                    }}
                                    hidden
                                    multiple
                                  />
                                  <button
                                    className={`btn-xs !text-white !text-sm md:!flex-grow-0 !flex-grow ${
                                      userinternal
                                        ? "!bg-[--bg-color-300] cursor-not-allowed"
                                        : "!bg-[--bg-color-500]"
                                    }`}
                                    type="button"
                                    onClick={(e) => {
                                      document.getElementById(item.id).click();
                                    }}
                                    disabled={userinternal}
                                  >
                                    <span className="text-sm">Upload</span>
                                  </button>
                                </div>
                                {fileNames.map(
                                  (file) =>
                                    item.id === file.id && (
                                      <div className="flex flex-row items-center justify-between px-3 space-y-1">
                                        <div
                                          title={file.fileName}
                                          className="text-sm"
                                        >
                                          {file.fileName.length > 35
                                            ? file.fileName?.substr(0, 35) +
                                              "..." +
                                              file.fileName?.split(".")[1]
                                            : file.fileName}
                                        </div>
                                        <span
                                          className="fa-light fa-trash-can text-base cursor-pointer"
                                          style={{ color: "#eb5757" }}
                                          onClick={() => {
                                            setFileData((prev) => {
                                              const index = prev.findIndex(
                                                (ele) => item.id === ele.id
                                              );
                                              const filterFiles = prev[
                                                index
                                              ].upload.filter(
                                                (item) =>
                                                  item.name !== file.fileName
                                              );
                                              prev[index].upload = filterFiles;
                                              return prev;
                                            });
                                            let files = [];
                                            for (const ele of fileNames) {
                                              if (
                                                item.id === ele.id &&
                                                ele.fileName === file.fileName
                                              ) {
                                                continue;
                                              }
                                              files.push(ele);
                                            }
                                            setFileNames(files);
                                          }}
                                        ></span>
                                      </div>
                                    )
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex justify-end space-x-2 mt-2">
              {editstate === false ? (
                <div className="space-x-2">
                  <button
                    className={`btn text-white text-sm ${
                      userinternal
                        ? "!bg-[--bg-color-300] cursor-not-allowed"
                        : "!bg-[--bg-color-500]"
                    }`}
                    type="submit"
                    disabled={userinternal}
                    onClick={(e) => {
                      e.stopPropagation();
                      const status = getPerformActivity(userinfo);
                      if (status) {
                        setRenderData(false);
                        if (
                          activitydata.based_on === "Document" &&
                          activitydata.label === ""
                        ) {
                          checkValidation(activitydata, "Save");
                        } else if (
                          (activitydata.based_on === "Document" ||
                            activitydata.based_on === "Container") &&
                          activityPerformance.based_on !== null &&
                          activityPerformance.based_on[0] !== null &&
                          activityPerformance.based_on?.length !== 0
                        ) {
                          checkValidation(activitydata, "Save");
                        } else {
                          setShowAlert(true);
                          setMessage({
                            type: "info",
                            title: "Field Validation",
                            message: `${basedon} is required and it cannot be empty. Please add some`,
                          });
                        }
                      } else {
                        setInternalUserAlert(true);
                      }
                    }}
                  >
                    Submit
                  </button>
                  {/* { userinfo?.loop_activity === null && tableData.length === 0 && (
                      <button
                      className={`btn text-white text-sm ${
                        userinternal
                          ? "!bg-[--bg-color-300] cursor-not-allowed"
                          : "!bg-[--bg-color-500]"
                      }`}
                      type="submit"
                      disabled={userinternal}
                      onClick={(e) => {
                        e.stopPropagation();
                        const status = getPerformActivity(userinfo);
                        if (status) {
                          setRenderData(false);
                          if (
                            activitydata.based_on === "Document" &&
                            activitydata.label === "" 
                          ){
                            checkValidation(activitydata, "Complete")
                          }
                          else if (
                            (activitydata.based_on === "Document" || 
                            activitydata.based_on === "Container") &&
                            activityPerformance.based_on !== null &&
                            activityPerformance.based_on[0] !== null &&
                            activityPerformance.based_on?.length !== 0
                          ) {
                            checkValidation(activitydata, "Complete");
                          } else {
                            setShowAlert(true);
                            setMessage({
                              type: "info",
                              title: "Field Validation",
                              message: `${basedon} is required and it cannot be empty. Please add some`,
                            });
                          }
                        } else {
                          setInternalUserAlert(true);
                        }
                      }}
                    >
                      Complete
                    </button>)}
                    { userinfo?.loop_activity === null && tableData.length > 0 && (<button
                      className={`btn text-white text-sm ${
                        userinternal
                          ? "!bg-[--bg-color-300] cursor-not-allowed"
                          : "!bg-[--bg-color-500]"
                      }`}
                      type="submit"
                      disabled={userinternal}
                      onClick={(e) => {
                        e.stopPropagation();
                        const status = getPerformActivity(userinfo);
                        if (status) {
                          setRenderData(false);
                          handleComplete(activitydata, "Complete")
                        } else {
                          setInternalUserAlert(true);
                        }
                      }}
                    >
                      Complete
                    </button>)} */}
                </div>
              ) : (
                <div className="flex justify-start space-x-2">
                  <button
                    className="btn-sm bg-white border-slate-200 hover:border-slate-300 text-slate-600text-sm"
                    onClick={() => {
                      setEditState(false);
                      setSubmitPerform(true);
                      setRenderData(false);
                      setFileNames([]);
                      setSelected([]);
                      setShowAllAsset([]);
                      setValidateObj([]);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn-sm !bg-[--bg-color-500] text-white text-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      const status = getPerformActivity(userinfo);
                      if (status) {
                        if (validateobj.length === 0) {
                          updateActivityPerformance();
                          setEditState(false);
                          setSubmitPerform(true);
                          setRenderData(false);
                        }
                      } else {
                        setInternalUserAlert(true);
                      }
                    }}
                  >
                    Update
                  </button>
                </div>
              )}
            </div>
          </form>
          <div id="container2" className="flex justify-between py-4">
            <div className="w-full">
              <div className="border bg-white shadow-md rounded-md">
                <DataTable
                  columns={tableColumn}
                  data={tableData}
                  highlightOnHover
                  progressPending={!tableData}
                  responsive
                  striped
                  fixedHeader
                  customStyles={customStyles}
                  expandableRows={header.length > 5}
                  expandableRowsComponent={ExpandedComponent}
                  expandOnRowClicked={false}
                  expandOnRowDoubleClicked={false}
                  expandableRowsHideExpander={false}
                  sortIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                      className="fill-current"
                      style={{
                        display: "block !important",
                        // opacity: 1,
                        color: "#94a3b8",
                      }}
                    >
                      <path d="M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z" />
                    </svg>
                  }
                />
              </div>
              <br />
            </div>
          </div>
        </>
      ) : null}
      <br />
    </div>
  );
};

export default UpdateActivity;
